import { useMemo } from "react"
import { useRecoilValue } from "recoil"
import { currentPatientFileInfoAtom } from "../Atoms/PatientFile"
import { modalityTimesAtom, ModalityTimeRow } from "../Atoms/ModalityTimes"
import { ModalityJumpTarget } from "../Utils/modalityJumpTargets"

type TargetBuilder = (rows: ModalityTimeRow[], fileStart: number, fileEnd: number) => ModalityJumpTarget[]

export function useModalityJumpTargets(
	fileStart: Date,
	fileEnd: Date,
	builder: TargetBuilder
): ModalityJumpTarget[] {
	const { patientId } = useRecoilValue(currentPatientFileInfoAtom)
	const modalityTimesByPatient = useRecoilValue(modalityTimesAtom)

	return useMemo(() => {
		if (typeof patientId !== "number") {
			return []
		}

		const rows = modalityTimesByPatient[patientId]
		if (!rows || rows.length === 0) {
			return []
		}

		return builder(rows, fileStart.getTime(), fileEnd.getTime())
	}, [fileStart, fileEnd, modalityTimesByPatient, patientId, builder])
}
